import React from "react";
import { useHistory } from "react-router-dom";
import PageWrapper from "../PageWrapper";
import PrimaryButton from "../SFUCentralThemedComponents/PrimaryButton";

export default function InitialLandingPage() {
  const history = useHistory();
  return (
    <PageWrapper>
      <div className="p-col-12">
        Please select a scholarship:
        <br />
        <br />
        <PrimaryButton
          type="button"
          onClick={() => {
            history.push("/uggla-family-scholarship");
          }}
        >
          Uggla Family Scholarship
        </PrimaryButton>
        {/* <PrimaryButton
          type="button"
          onClick={() => {
            history.push("/fas-scholarship");
          }}
        >
          FAS Scholarship
        </PrimaryButton> */}
      </div>
    </PageWrapper>
  );
}
